export default "__VITE_ASSET__c76608b6__"